import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    class: "box-panel"
};
const _hoisted_2 = {
    class: "cont"
};
const _hoisted_3 = {
    class: "cell"
};
const _hoisted_4 = [
    "onClick"
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return _openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.routeList, (item, index)=>{
            return _openBlock(), _createElementBlock("div", {
                key: index
            }, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (i, i_index)=>{
                        return _openBlock(), _createElementBlock("div", {
                            class: _normalizeClass({
                                tag: true,
                                checked: $data.route === i.value
                            }),
                            key: i_index,
                            onClick: ($event)=>$options.onChange(i.value)
                        }, _toDisplayString(i.label), 11, _hoisted_4);
                    }), 128))
                ])
            ]);
        }), 128))
    ]);
}
